(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveals(raiz) {
    (raiz || document).querySelectorAll('.mt-reveal, [data-mt-reveal]').forEach(function (el) {
      if (el.dataset.mtObs) return; el.dataset.mtObs = '1';
      if (!io || reducido) { el.classList.add('mt-visible'); return; }
      io.observe(el);
    });
  }

  // Hotspots (#17)
  function initHotspots(raiz) {
    (raiz || document).querySelectorAll('[data-mt-hotspots]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('.mt-hs__punto');
      var items = sec.querySelectorAll('.mt-hs__item');
      function activar(i) {
        puntos.forEach(function (p, j) { p.classList.toggle('mt-activo', j === i); });
        items.forEach(function (it, j) { it.classList.toggle('mt-activo', j === i); });
      }
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activar(i); }); p.addEventListener('mouseenter', function () { activar(i); }); });
      items.forEach(function (it, i) { it.addEventListener('click', function () { activar(i); }); it.addEventListener('mouseenter', function () { activar(i); }); });
      activar(0);
    });
  }

  // Selector de escenario (#77)
  function initEscenarios(raiz) {
    (raiz || document).querySelectorAll('[data-mt-escenarios]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var tabs = sec.querySelectorAll('.mt-esc__tab');
      var fotos = sec.querySelectorAll('.mt-esc__fotos img');
      var textos = sec.querySelectorAll('.mt-esc__texto');
      var actual = 0, timer = null;
      var auto = parseInt(sec.dataset.auto || '0', 10);
      function ir(i) {
        actual = i;
        [tabs, fotos, textos].forEach(function (lista) { lista.forEach(function (el, j) { el.classList.toggle('mt-activo', j === i); }); });
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
      }
      function programar() { if (!auto || reducido) return; clearInterval(timer); timer = setInterval(function () { ir((actual + 1) % tabs.length); }, auto * 1000); }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { ir(i); programar(); }); });
      sec.addEventListener('mouseenter', function () { clearInterval(timer); });
      sec.addEventListener('mouseleave', programar);
      ir(0); programar();
    });
  }

  // FAQ (#80)
  function initFaq(raiz) {
    (raiz || document).querySelectorAll('[data-mt-faq]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      sec.querySelectorAll('.mt-faq__item').forEach(function (item) {
        var b = item.querySelector('.mt-faq__preg');
        b.addEventListener('click', function () {
          var abierto = item.classList.toggle('mt-abierto');
          b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        });
      });
    });
  }

  // CTA magnético (#88)
  function initMagneticos(raiz) {
    if (reducido || !window.matchMedia('(hover: hover)').matches) return;
    (raiz || document).querySelectorAll('.mt-magnetico').forEach(function (btn) {
      if (btn.dataset.mtInit) return; btn.dataset.mtInit = '1';
      var zona = btn.parentElement;
      zona.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 140) btn.style.transform = 'translate(' + (dx * 0.06).toFixed(1) + 'px,' + (dy * 0.1).toFixed(1) + 'px)';
        else btn.style.transform = '';
      });
      zona.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  // Galería y cantidad de la página de producto
  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var principal = sec.querySelector('.mt-prod__principal img');
      sec.querySelectorAll('.mt-prod__mini').forEach(function (m) {
        m.addEventListener('click', function () {
          sec.querySelectorAll('.mt-prod__mini').forEach(function (x) { x.classList.remove('mt-activo'); });
          m.classList.add('mt-activo');
          if (principal) { principal.style.opacity = 0; setTimeout(function () { principal.src = m.dataset.src; principal.style.opacity = 1; }, 180); }
        });
      });
      var input = sec.querySelector('.mt-prod__cantidad input');
      sec.querySelectorAll('.mt-prod__cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10) + parseInt(b.dataset.paso, 10);
          input.value = Math.max(1, v);
        });
      });
      // Variantes
      var datos = sec.querySelector('[data-mt-variantes]');
      var selects = sec.querySelectorAll('[data-mt-opcion]');
      if (datos && selects.length) {
        var variantes = JSON.parse(datos.textContent);
        var idInput = sec.querySelector('input[name="id"]');
        var precio = sec.querySelector('[data-mt-precio]');
        var tachado = sec.querySelector('[data-mt-tachado]');
        var boton = sec.querySelector('[data-mt-boton]');
        function fmt(c) { return '$' + Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
        selects.forEach(function (s) {
          s.addEventListener('change', function () {
            var elegidas = Array.prototype.map.call(selects, function (x) { return x.value; });
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
            if (!v) { boton.disabled = true; boton.textContent = boton.dataset.noDisponible; return; }
            idInput.value = v.id;
            if (precio) precio.textContent = fmt(v.price);
            if (tachado) { tachado.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; }
            boton.disabled = !v.available;
            boton.textContent = v.available ? boton.dataset.texto : boton.dataset.agotado;
          });
        });
      }
    });
  }

  // Cuenta regresiva de la franja de oferta (hora de Chile continental en verano: UTC-3)
  function initPromo(raiz) {
    (raiz || document).querySelectorAll('[data-mt-promo]').forEach(function (sec) {
      if (sec.dataset.mtInit) return; sec.dataset.mtInit = '1';
      var txt = (sec.dataset.fin || '').trim();
      if (!txt) return;
      var fin = new Date(txt.replace(' ', 'T') + (txt.length <= 16 ? ':00' : '') + '-03:00').getTime();
      if (isNaN(fin)) return;
      var d = sec.querySelector('[data-d]'), h = sec.querySelector('[data-h]'), m = sec.querySelector('[data-m]'), s = sec.querySelector('[data-s]');
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function tic() {
        var r = Math.floor((fin - Date.now()) / 1000);
        if (r <= 0) { var w = sec.closest('.shopify-section') || sec; w.style.display = 'none'; clearInterval(t); return; }
        if (d) d.textContent = Math.floor(r / 86400);
        if (h) h.textContent = dos(Math.floor(r % 86400 / 3600));
        if (m) m.textContent = dos(Math.floor(r % 3600 / 60));
        if (s) s.textContent = dos(r % 60);
      }
      var t = setInterval(tic, 1000); tic();
    });
  }

  function initTodo(e) {
    var raiz = e && e.target && e.target.querySelectorAll ? e.target : document;
    initPromo(raiz);
    initReveals(raiz); initHotspots(raiz); initEscenarios(raiz); initFaq(raiz); initMagneticos(raiz); initProducto(raiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
